import { ToolbarItem } from "./toolbaritem";

export class Toolbar {

  /**
   * @type {ImageEditor}
   */
  imageEditor = null;

  /**
   * @type {HTMLElement}
   */
  element = null;

  /**
   * @type {ToolbarItem[]}
   */
  items = [];

  /**
   * Constructor.
   * @param {ImageEditor} imageEditor 
   */
  constructor(imageEditor, element) {
    this.imageEditor = imageEditor;
    this.element = element;
  }

  /**
   * Add an item to the toolbar.
   * @param {ToolbarItem} toolbarItem 
   */
  addItem(toolbarItem) {
    this.items.push(toolbarItem);
  }

}